import { Body, Box, Divider, Heading } from "@biom3/react";
import Link from "next/link";

export const RewardsFAQsSection = () => {
  return (
    <Box sx={{ width: "100%", mt: "base.spacing.x6" }}>
      <Divider
        sx={{
          bg: "base.color.translucent.emphasis.100",
          mb: "base.spacing.x4",
        }}
      />
      <Heading
        size="medium"
        weight="bold"
        sx={{
          mb: "base.spacing.x6",
          color: "base.color.text.heading.primary",
        }}
      >
        FAQs
      </Heading>
      <Box sx={{ mb: "base.spacing.x10" }}>
        <Body size="medium">
          Our in-depth FAQ page covers everything you need to know - from how to
          qualify and redeem Gems to verifying your account for extra security.
          If you are unsure about any part of the process, head to the{" "}
          <Link href="/rewards/faq/" rel="noopener noreferrer">
            FAQ page
          </Link>{" "}
          for clear, step-by-step answers.
        </Body>
      </Box>
    </Box>
  );
};
